import { userIntentAtom } from "@/store/login";
import { useAtomValue } from "jotai";
import type { FC } from "react";
import AddPaymentDialog from "./AddPaymentDialog";

interface PaymentActionsProps {
	size?: "sm" | "md" | "lg";
}

/**
 * Paying someone and being paid are different jobs, so they get their own
 * buttons. Which ones show follows the user's intent: buyers send, sellers
 * record what they received, and "both" gets both.
 */
const PaymentActions: FC<PaymentActionsProps> = ({ size }) => {
	const intent = useAtomValue(userIntentAtom);
	const canSend = intent !== "SELL";
	const canReceive = intent !== "BUY";

	return (
		<div className="flex items-center gap-2">
			{canSend && <AddPaymentDialog direction="send" size={size} />}
			{canReceive && (
				<AddPaymentDialog
					direction="receive"
					size={size}
					color={canSend ? "secondary" : "primary"}
				/>
			)}
		</div>
	);
};

export default PaymentActions;
